module.exports = __webpack_public_path__ + "static/eula-banner-a5195faa0575fb5ae0307c1d39630d20.png";